<script setup lang="ts">
import { scroll } from '@/shared/utils/scrollBehavior';
import type { IInfoStreetLinkProps } from '@/widgets/LawyerCard/model/types/lawyerCard';

defineProps<IInfoStreetLinkProps>();

const isMobile: boolean = useIsMobile();

const scrollToContacts = (): void => {
  const contacts = document.getElementById('contacts');
  scroll(contacts);
};
</script>

<template>
  <div :class="['info-street-link', { _mobile: isMobile }]">
    <button
      class="info-street-link__button"
      :aria-label="`${street}: перейти к контактам и адресу`"
      @click.prevent="scrollToContacts"
    >
      <span class="info-street-link__text">{{ street }}</span>
    </button>
  </div>
</template>

<style lang="less">
.info-street-link {
  display: inline-flex;
  margin-top: 8px;
  padding-left: 0;

  &__button {
    display: inline-flex;
    align-items: center;
  }

  &__text {
    font-weight: 500;
    font-size: @size-x3;
    line-height: @size-x4;
    display: inline-block;
    color: @color-dove-gray;
    text-align: left;
  }

  &._mobile {
    margin-top: 6px;
  }

  &._mobile &__text {
    font-size: @size-x3;
    line-height: @size-x4;
  }
}
</style>
